import { api } from './client';

export type AdvisoryLevel = 'normal' | 'see_advisory' | 'avoid_essential' | 'avoid_all';
export type VisaStatus =
  | 'visa_free' | 'visa_on_arrival' | 'e_visa' | 'eta' | 'visa_required' | 'no_admission';
export type TapWater = 'safe' | 'caution' | 'unsafe';

export interface CountryPractical {
  plugs: string[];
  voltage: string;
  frequency: string;
  driving: 'left' | 'right';
  emergency: { general?: string; police?: string; ambulance?: string; fire?: string };
  tapWater: TapWater;
}

export interface CountryEssentials {
  countryCode: string;
  countryName: string | null;
  currency: { code: string; name: string; symbol: string | null } | null;
  callingCode: string | null;
  capital: string | null;
  languages: string[];
  flag: string | null;
  region: string | null;
  practical: CountryPractical | null;
  advisory: { level: AdvisoryLevel; url: string; updatedAt: string | null; source: 'fcdo' } | null;
}

export interface EssentialsResponse {
  /** The first country — what builds before ADR-0030 read. */
  country: { code: string; name: string | null } | null;
  essentials: CountryEssentials | null;
  /** ADR-0030: one per country the trip visits, in travel order. */
  countries: { country: { code: string; name: string | null }; essentials: CountryEssentials }[];
}

export interface EntryRequirement {
  destination: string;
  nationality: string;
  nationalityName: string;
  nationalityFlag: string | null;
  travellers: string[];
  visa: { status: VisaStatus; days?: number } | null;
  passportValidityMonths: number;
  vaccinesRequired: string[];
  vaccinesRecommended: string[];
  healthNotes: string;
  officialUrl: string;
  source: { visa: string; health: string };
  checkedAt: string;
}

export interface RequirementsResponse {
  /** The first country — what builds before ADR-0030 read. */
  country: { code: string; name: string | null } | null;
  requirements: EntryRequirement[];
  missingNationality: boolean;
  /** ADR-0030: one per country the trip visits, in travel order. */
  countries: { country: { code: string; name: string | null }; requirements: EntryRequirement[] }[];
}

export const essentialsApi = {
  get: (tripId: string, locale?: string) =>
    api.get<EssentialsResponse>(`/trips/${tripId}/essentials`, { params: { locale } }).then(r => r.data),
  requirements: (tripId: string, locale?: string) =>
    api.get<RequirementsResponse>(`/trips/${tripId}/essentials/requirements`, { params: { locale } }).then(r => r.data),
  setNationality: (tripId: string, nationalityCode: string | null) =>
    api.patch<void>(`/trips/${tripId}/essentials/nationality`, { nationalityCode }).then(r => r.data),
};
